export const state = {
  map: null,
  map2: null,
  isCompareMode: false,
  draw: null,
  mapReady: false,
  map2Ready: false,
  features: {
    type: 'FeatureCollection',
    features: []
  },
  feedFeatures: {
    type: 'FeatureCollection',
    features: []
  },

  orgLayers: [],

  currentFeature: null,
  currentFeatureChilds: null,

  page: 1,
  perPage: 10,

  planetFeaturesEnabled: false,
  beacons: [],

  notes: [],

  tilesSettings: null,
  tilesMosaics: [],

  files: null,
  layers: null,
  reportTemplates: null,

  isFeatureCreated: false,
  totalOnMap: 0,
  projectBoundariesVisible: true,
  
  // Feature visibility state - tracks which features are visible on map
  // Key: feature code, Value: boolean (true = visible, false = hidden)
  featureVisibility: {},
}
